<template>
  <w-dialog
    ref="export-log"
    title="选择导出字段"
    width="50%"
    sureBtnText="导出"
    @handleClose="handleCloseExport"
    @handleCloseRight="handleCloseExport"
    @onSure="onSureExport">
    <template v-slot:content>
      <div class="dialog-content export-span">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange">
          全选
        </el-checkbox>
        <div style="margin: 0.9375rem 0"></div>
        <el-checkbox-group
          v-model="checkedOrders"
          @change="handleCheckedOrdersChange">
          <el-checkbox
            style="margin-bottom: 0.625rem"
            v-for="item in orderOptions"
            :label="item.key"
            :key="item.key">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </template>
  </w-dialog>
</template>
<script>
import WDialog from '@/components/Model/index.vue'
import staticDataConfig from '@/views/MiBicycle/staticData.js'
import { compare, downloadExcel } from '@/utils/tools'
import Api from '@/api'
export default {
  name: 'inspectionLogExport-dialog',
  components: {
    WDialog
  },
  props: {
    // 接收父组件传递的查询条件
    queryParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 系统考核导出
      orderOptions: [],
      checkedOrders: [],
      isIndeterminate: true,
      checkAll: false,
      exportParams: {}
    }
  },
  watch: {
    queryParams: {
      handler(newVal) {
        this.queryParams = newVal
      },
      deep: true
    }
  },
  created() {
    this.orderOptions = staticDataConfig.wccl_xcrz.columns.map(item => ({
      key: item.prop,
      label: item.label
    }))
  },
  methods: {
    onExport(params) {
      console.log('params:', params)
      this.exportParams = { ...params }
      this.$refs['export-log'].onShowDialog()
    },
    handleCloseExport() {
      this.checkedOrders = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['export-log'].onCloseDialog()
    },
    handleCheckAllChange(val) {
      this.checkedOrders = val ? this.orderOptions.map((item) => item.key) : []
      this.isIndeterminate = false
    },
    handleCheckedOrdersChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.orderOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.orderOptions.length
    },
    // 确认导出
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      this.exportParams.export = this.checkedOrders && this.checkedOrders.length
        ? this.checkedOrders.sort(compare).join(',')
        : ''
      if (vm.exportParams.export) {
        Api.exportInspectionLogStatistics(this.exportParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    }
  }
}
</script>
<style scoped lang="less">

</style>
